import { useState, useEffect, useRef } from "react";
import Config from "../../Config";


import back from "../../back.png";
import AppContext from "../../AppContext";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import SortBy from "../../helpers/SortBy";

function GmAccounts(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [view, setView] = useState ( "list");

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({          
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''), 
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        data_utworzenia: props.mainView.readFilter('data_utworzenia',''),

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });

        
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [dates, setDates] = useState(null);
    const [tab, setTab] = useState(null);



     const getDates = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_rap,dates2', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setDates(res.result);                                
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


   const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_rap,general2', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

  




    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', ''); 
        props.mainView.writeFilter('p_group_id', '_x_');
        props.mainView.writeFilter('data_utworzenia', '0');

        setFilterParam({ 
            d_imie_nazwisko: '',  
            p_grupa_id: '_x_',
            data_utworzenia: 0,    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },


            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }


    if(tab == null)
    {        
        setTab([]);
        getDates();
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }




    var sumSaldo = 0;

    var sumPrzypisCzesne = 0;
    var sumOdpisCzesne = 0;
    var sumCzesne = 0;

 
    var sumPrzypisWyzywienie = 0;
    var sumOdpisWyzywienie = 0;
    var sumWyzywienie = 0;

    var sumPrzypisInne = 0;
    var sumOdpisInne = 0;
    var sumInne = 0;

    for(var k=0; k< tab.length; k++)
    {
        sumSaldo = parseFloat( tab[k].saldo) + parseFloat(sumSaldo);

        sumPrzypisCzesne  = parseFloat( tab[k].przypis_czesne) + parseFloat(sumPrzypisCzesne);
        sumOdpisCzesne    = parseFloat( tab[k].odpis_czesne) + parseFloat(sumOdpisCzesne);
        sumCzesne         = parseFloat( tab[k].razem_czesne) + parseFloat(sumCzesne);

        sumPrzypisWyzywienie  = parseFloat( tab[k].przypis_wyzywienie) + parseFloat(sumPrzypisWyzywienie);
        sumOdpisWyzywienie    = parseFloat( tab[k].odpis_wyzywienie) + parseFloat(sumOdpisWyzywienie);
        sumWyzywienie         = parseFloat( tab[k].razem_wyzywienie) + parseFloat(sumWyzywienie);

        sumPrzypisInne  = parseFloat( tab[k].przypis_inne) + parseFloat(sumPrzypisInne);
        sumOdpisInne    = parseFloat( tab[k].odpis_inne) + parseFloat(sumOdpisInne);
        sumInne         = parseFloat( tab[k].razem_inne) + parseFloat(sumInne);
    }


    return <div>

                    <br/>
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                    <h3>Bilans kont</h3>    

        
                    <div className="table_filter">
                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 

                
                            <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  

                             <div className="filter_controll">   
                                <label>Data wygenerowania raportu: </label>                             
                                <InputCombo items={dates}    value={filterParam.data_utworzenia}   valChange={valChangeListener} goNext={goNextNew} name="data_utworzenia" placeholder={"Data utworzenia: "}   />
                            </div> 


                             <div className="filter_btn">                           
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                    </div>


                    <div className="table_widget">

                      
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={"Raport ogólny"} />   
                            <Csv tabRef={tab2Ref}  title={"Raport ogólny"} />                  
                            <Xlsx tabRef={tab2Ref}  title={"Raport ogólny"} />                  
                            <Print tabRef={tab2Ref}   userData={props.userData} mainView={props.mainView}  title={"Raport ogólny"} />                                   
                    </div>


                    <div className="bg_center">


                            <div ref={tabRef} className="gohide">
                                    <h3>Bilans sald</h3>   
                                

                                        <thead>
                                            <tr className="header">                                 
                                                <td className="td_left">LP</td>
                                                <td>Wpis na dzień</td>                                                  
                                                <td>Nazwisko, imię</td>    
                                                <td>Czesne</td>  
                                                <td>Wyżywienie</td>  
                                                <td>Inne</td>  
                                                <td>Razem</td>  
                                                <td>Gotówka / Czesne</td>  
                                                <td>Gotówka / Wyżywienie</td>  
                                                <td>Gotówka / Inne</td>  
                                                <td>Gotówka / Razem</td>  
                                                <td>Przelew / Czesne</td>  
                                                <td>Przelew / Wyżywienie</td>  
                                                <td>Przelew / Inne</td>  
                                                <td>Przelew / Razem</td>  
                                                <td>Umorzenia</td>  
                                                <td>Saldo dziecka</td>  
                                                <td>Saldo rodzica</td>  
                                                <td className="td_right">Przelewy</td>                                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (item, ix) => {

                                                        
                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            return  <tr  className={rowStyle} >                                 
                                                                <td className="td_left">{ix+1}</td>
                                                                <td className="gocenter">{item.data_wygenerowania_raportu}</td>                                                  
                                                                <td>{item.dziecko.nazwisko} {item.dziecko.imie}</td>    
                                                                <td className="goright"><FormatDecimal value={item.czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.wyzywienie}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.inne}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.razem}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.gotowka_czesne}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.gotowa_wyzywienie}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.gotowka_inne}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.gotowka_razem}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.przelew_czesne}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.przelew_wyzywienie}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.przelew_inne}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.przelew_razem}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.przelew_wirtualny_umorzenia}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.saldo_dziecka}/></td>  
                                                                <td className="goright"><FormatDecimal value={item.saldo_rodzica}/></td>  
                                                                <td className="td_right">{item.przelewy_txt}</td>                                                                                                  
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>
                            <table className="table" ref={tabRef}>

                                        <thead>
                                            <tr className="header">                                 
                                                <td className="td_left">LP</td>
                                                <td>Wpis na dzień</td>                                                  
                                                <td>Dziecko</td>                                                  
                                                <td>Saldo</td>                                                  
                                                <td>Przypis czesne</td>                                                  
                                                <td>Odpis czesne</td>                                                  
                                                <td>Czesne</td>                                                  
                                                <td>Przypis wyżywienie</td>                                                  
                                                <td>Odpis wyżywienie</td>                                                  
                                                <td>Wyżywienie</td>                                                  
                                                <td>Przypis inne</td>                                                  
                                                <td>Odpis inne</td>                                                  
                                                <td className="td_right">Inne</td>                                                                                                                                                                                              
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (item, ix) => {

                                                        
                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            return  <tr  className={rowStyle} >                                 
                                                                <td className="td_left">{ix+1}</td>
                                                                <td className="gocenter">{item.dzien}</td>                                                  
                                                                <td>{item.dziecko.nazwisko} {item.dziecko.imie}</td>    
                                                                <td className="goright"><FormatDecimal value={item.saldo}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.przypis_czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.odpis_czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.razem_czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.przypis_wyzywienie}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.odpis_wyzywienie}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.razem_wyzywienie}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.przypis_inne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.odpis_inne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.razem_inne}/> </td>                                                                                                                                                                                                               
                                                            </tr>

                                                    } )
                                                }
 

                                                            <tr>                                 
                                                                <td className="td_left"> </td>
                                                                <td className="gocenter"> </td>                                                  
                                                                <td> </td>    
                                                                <td className="goright gobold"><FormatDecimal value={sumSaldo}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumPrzypisCzesne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumOdpisCzesne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumCzesne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumPrzypisWyzywienie}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumOdpisWyzywienie}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumWyzywienie}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumPrzypisInne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumOdpisInne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumInne}/> </td>                                                                                                                                                                                                               
                                                            </tr>

                                        </tbody>
                            </table>
                            </div>

                      
                            <table className="table" ref={tabRef}>

                                        <thead>
                                            <tr className="header">                                 
                                                <td className="td_left">LP</td>
                                                <td>Wpis na dzień</td>                                                  
                                                <td>Dziecko</td>                                                  
                                                <td>Saldo</td>                                                  
                                                <td>Przypis czesne</td>                                                  
                                                <td>Odpis czesne</td>                                                  
                                                <td>Czesne</td>                                                  
                                                <td>Przypis wyżywienie</td>                                                  
                                                <td>Odpis wyżywienie</td>                                                  
                                                <td>Wyżywienie</td>                                                  
                                                <td>Przypis inne</td>                                                  
                                                <td>Odpis inne</td>                                                  
                                                <td className="td_right">Inne</td>                                                                                                                                                                                              
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (item, ix) => {

                                                        
                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            return  <tr  className={rowStyle} >                                 
                                                                <td className="td_left">{ix+1}</td>
                                                                <td className="gocenter">{item.dzien}</td>                                                  
                                                                <td>{item.dziecko.nazwisko} {item.dziecko.imie}</td>    
                                                                <td className="goright"><FormatDecimal value={item.saldo}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.przypis_czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.odpis_czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.razem_czesne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.przypis_wyzywienie}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.odpis_wyzywienie}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.razem_wyzywienie}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.przypis_inne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.odpis_inne}/> </td>  
                                                                <td className="goright"><FormatDecimal value={item.razem_inne}/> </td>                                                                                                                                                                                                               
                                                            </tr>

                                                    } )
                                                }
 

                                                            <tr>                                 
                                                                <td className="td_left"> </td>
                                                                <td className="gocenter"> </td>                                                  
                                                                <td> </td>    
                                                                <td className="goright gobold"><FormatDecimal value={sumSaldo}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumPrzypisCzesne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumOdpisCzesne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumCzesne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumPrzypisWyzywienie}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumOdpisWyzywienie}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumWyzywienie}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumPrzypisInne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumOdpisInne}/> </td>  
                                                                <td className="goright gobold"><FormatDecimal value={sumInne}/> </td>                                                                                                                                                                                                               
                                                            </tr>

                                        </tbody>
                            </table>
                        

                           

                    </div>

    </div>
}


export default GmAccounts;